import { useAuth } from "@hooks/useAuth";
import { Permission } from "../components/Auth/permissions";

export const onlyForAuthenticated = (comp) => {
	const Component = comp;
	return function WrappedComponent(props) {
		const { isAuthenticated } = useAuth();
		if (!isAuthenticated) {
			return null;
		}
		return <Component {...props} />;
	};
};

export const onlyForUWRS = (comp) => {
	const Component = comp;
	return function WrappedComponent(props) {
		const { user } = useAuth();
		if (!user?.uwr) {
			return null;
		}
		return <Component {...props} />;
	};
};

export const onlyForPermission = (
	comp,
	{ org = "none", permission = Permission.SEALORD, checkUwr = false }
) => {
	const Component = comp;
	return function WrappedComponent(props) {
		const { checkPermissions } = useAuth();
		const hasAccess = checkPermissions(org, permission, checkUwr);
		if (!hasAccess) {
			return null;
		}
		return <Component {...props} />;
	};
};

export const onlyForSealord = (comp) =>
	onlyForPermission(comp, {
		org: "none",
		permission: Permission.SEALORD,
		checkUwr: false,
	});

export const onlyForClaimsHandler = (comp) =>
	onlyForPermission(comp, {
		org: "none",
		permission: Permission.CLAIMS_HANDLER,
		checkUwr: false,
	});
